import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import ContainerPlugin from '../../uplus-api/container/container-plugin';
import ExecutionResult from '../../uplus-api/container/execution-result';
export var NebulaPlugin = function (_ContainerPlugin) {
    _inherits(NebulaPlugin, _ContainerPlugin);

    function NebulaPlugin() {
        _classCallCheck(this, NebulaPlugin);

        // @ts-ignore
        var _this = _possibleConstructorReturn(this, (NebulaPlugin.__proto__ || Object.getPrototypeOf(NebulaPlugin)).call(this));

        _this.nebulaPlugin = window.AlipayJSBridge;
        // if (this.nebulaPlugin === null) {
        //   throw Error('未正常获得AlipayJSBridge实例');
        // }
        return _this;
    }

    _createClass(NebulaPlugin, [{
        key: 'generateCallbackFunc',
        value: function generateCallbackFunc(callback, handler) {
            return function (ret) {
                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                    if (handler) {
                        var data = handler(ret);
                        callback(new ExecutionResult('000000', data !== (null || undefined) ? data : ''));
                    } else {
                        callback(new ExecutionResult('000000', ret && ret.retData !== (null || undefined) ? ret.retData : ''));
                    }
                } else {
                    callback(new ExecutionResult('000001', ret && ret.retData !== (null || undefined) ? ret.retData : ''));
                }
            };
        }
    }, {
        key: 'generateRetDateCallbackFunc',
        value: function generateRetDateCallbackFunc(callback, handler) {
            return function (ret) {
                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                    if (handler) {
                        var data = handler(ret);
                        callback(new ExecutionResult('000000', data !== (null || undefined) ? data : ''));
                    } else {
                        callback(new ExecutionResult('000000', ret && ret.retData !== (null || undefined) ? ret.retData : ''));
                    }
                } else {
                    callback(new ExecutionResult(ret.retCode, ret && ret.retData !== (null || undefined) ? ret.retData : ''));
                }
            };
        }
    }]);

    return NebulaPlugin;
}(ContainerPlugin);